import { createSignal } from "solid-js"

const [isKeyDownEnabled, setKeyDownEnabled] = createSignal(true)

export { isKeyDownEnabled, setKeyDownEnabled }
